<template>
    <modal class="scanPayModal" :isShow="isShow" @mousedown.prevent @keyup.esc="hide">
        <div class="header">扫码支付</div>
        <div class="modal-body">
            <!-- 支付完成 -->
            <div class="pay-complete-box" v-if="isComplete">
                <i class="iconfont icon-zhifuchenggong"></i>
                <div class="name">支付成功 欢迎下次光临</div>
                <div class="pay-money">支付：<span class="money">￥<span class="num">{{moneyInt}}.</span>{{moneyDecimal}}</span></div>
                <div class="total-money">合计：￥{{total.sumMoney}} 优惠：￥{{total.discountMoneuy}}</div>
            </div>
            <!-- 支付中 -->
            <div class="pay-loading-box" v-else>
                <div class="pay-select-time" :style="{ visibility:isOutTime?'':'hidden'}">支付剩余时间:<span class="time">{{psyOutTime}}</span>s</div>
                <div class="pay-money-box">
                    <span class="money">￥<span class="num">{{moneyInt}}.</span>{{moneyDecimal}}</span><span class="number">共{{total.number}}份</span>
                </div>
                <div class="loading-box" :style="{ visibility:loading?'':'hidden'}">
                    <div class="text">{{loadingText}}</div>
                    <div class="loading-ani">
                        <div class="dian" v-for="(item, index) in 10" :key="index"></div>
                    </div>
                </div>
                <div class="err-message">{{errorMes}}</div>
            </div>
        </div>
        <div class="footer-box">
            <template v-if="isComplete">
                <div class="btn btn-complete" @click="paySuccess()">完成交易(<count-down :duration="5" @success="paySuccess()"/>)</div>
            </template>
            <template v-else>
                <div class="btn btn-cancel" @click="hide()">
                    <i class="iconfont icon-suo" v-show="isOutTime || loading"></i>取消<div class="outTime" v-if="!isOutTime && !loading">(<count-down :duration="5" @success="hide()"/>)</div>
                </div>
                <div class="btn btn-border" @click="paySelect()">重新查询</div>
                <div class="btn btn-confirm"><i class="iconfont icon-suo"  v-show="isOutTime || loading"></i>确认</div>
            </template>
        </div>
    </modal>
</template>

<script>
export default {
    emits:["close","success"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
        //付款码
        payCode:{
            type:String,
            default:null
        },
    },
    computed:{
        parent(){
            return this.$parent.$parent;
        },
        //付款方式
        payTypeSSPay(){
            return this.parent.payTypeSSPay;
        },
        total(){
            return this.parent.total;
        },
        //应收正数位置
        moneyInt(){
            return parseInt(this.total.unPaidMoney);
        },
        //应收小数位
        moneyDecimal(){
            return Number(this.total.unPaidMoney).toFixed(2).split('.')[1];
        }
    },
    watch:{
        isShow(newVal){
            if(newVal){
                this.init();
            }
        },
        /**支付完成 */
        isComplete(newVal){
            if(newVal){
                //结束倒计时
                this.isOutTime=false;
                this.stopOutTime();
            }
        }
    },
    data(){
        return {
            //是否支付完成
            isComplete:false,
            loading:false,
            loadingText:"",
            //错误提示
            errorMes:"",
            //支付开始倒计时
            isOutTime:false,
            //支付剩余时间
            psyOutTime:60,
            //查询支付结果中
            isPaySelect:false,
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.isComplete=true;
            this.init();
        })
    },
    methods:{
        hide(){
            if(this.isComplete || (!this.isOutTime && !this.loading)){
                this.$emit('close');
                this.stopOutTime();
            }
        },
        //支付成功
        paySuccess(){
            this.$emit('success');
            this.stopOutTime();
        },
        init(){
            this.isComplete=false;
            this.loading=false;
            this.loadingText="";
            this.errorMes="";
            this.isOutTime=false;
            this.isPaySelect=false;
            this.payment(this.payCode);
        },
        select(){
            this.isComplete=!this.isComplete;
        },
        loadingShow(text){
            this.loading=true;
            this.loadingText=text;
        },
        stopOutTime(){
            if(this._outTime){
                clearTimeout(this._outTime);
            }
        },
        //开始倒计时
        startOutTime(time){
            if(time>0){
                this.isOutTime=true;
                this.psyOutTime=time;
            }
            this.stopOutTime();
            this._outTime=setTimeout(()=>{
                this.psyOutTime--;
                if(this.psyOutTime>0){
                    this.startOutTime();
                }else{
                    this.isOutTime=false;
                }
            },1000);
        },
        //扫码付款
        payment(payCode){
            this.loadingShow("支付提交中...");
            let param={
                Payments:[{//支付方式
                    Payment_ID:this.payTypeSSPay.PAY_ID, //支付方式ID
                    Payment_Code:this.payTypeSSPay.PAY_CODE,  //支付方式编号
                    Payment_Name:this.payTypeSSPay.PAY_NAME,  //支付方式名称
                    Payment_Type:this.payTypeSSPay.INTERFACE_TYPE,  //支付方式类型
                    Payment_Money:Number(this.total.unPaidMoney).toFixed(2), //支付方式金额
                    Payment_FactMoney:Number(this.total.unPaidMoney).toFixed(2),  //支付实收金额
                    Qr_Code:payCode, //扫码付款码值
                    Card_No:"", //卡号
                    CouponInfo:null, //该支付金额核销的券信息
                }],
            }
            this.parent.payPreview(param).then((d)=>{
                this.loading=false;
               
                if(d.ResponseBody?.Timestamps){
                    this.parent.Timestamps = d.ResponseBody?.Timestamps.toString();
                    this.parent.EatAutoID = d.ResponseBody?.Eat_AutoID;
                }
                if(d.ResponseHeader.ResultCode!=0){
                    let _error = d.ResponseHeader.ResultDesc
                    if(d.ResponseHeader.ResultDesc=='\r\n不支持的支付方式：,类型：0'){
                        _error ='该门店不支持聚合支付,请去后台设置相关功能';
                    }else if(d.ResponseHeader.ResultDesc?.trim()=="Invalid payment code"){
                        _error="无效付款码";
                    }
                    if(d.ResponseHeader.ResultCode==4001 || d.ResponseHeader.ResultCode==4002){
                        if(d.ResponseHeader.ResultDesc.indexOf("密码")>=0 && this.$cacheData.globalVariable?.GlobalSysSetting?.SilverStone_SsPay_NeedPwdVoice){//语音播报 请输入支付密码
                            this.$webBrowser.tts("请输入支付密码");
                        }
                        this.timeoutPayment();

                    }else if(d.ResponseHeader.ResultCode==4003){//用户已经取消支付
                        
                    }
                    this.errorMes=_error;
                    return;
                } else {
                    //是否需要调用提交接口 0不需要，1需要
                    if(d.ResponseBody.Is_NeedSubmit==1){
                        this.PaySubmit(d)
                    }else{
                        if(!d.ResponseBody?.IsMultipleCardPay){
                            if(d.ResponseBody?.PrintsInfo){
                                this.$webBrowser.posPrint(d.ResponseBody.PrintsInfo);
                            }
                            this.isComplete=true;
                        }
                    }
                    if(d.ResponseBody?.VoiceNotify){//语音提醒内容，如果返回不为空，前端可以发起一个语音播报
                        this.$webBrowser.tts(d.ResponseBody.VoiceNotify);
                    }
                }
            }).catch((e)=>{
                this.loading=false;
                this.errorMes=e.message;
            });
        },
        /**支付倒计时开始 */
        timeoutPayment(){
            if(!this.isOutTime){
                this.startOutTime(60);
            }
            if(this._timePay) clearTimeout(this._timePay);
            this._timePay=setTimeout(()=>{
                this.paySelect();
            },5000);
        },
        //查询支付结果
        paySelect(){
            if(this.isPaySelect || this.loading){
                return;
            }
            this.isPaySelect=true;
            this.loadingShow('等待查询支付结果中......');
            this.parent.paySelect().then((d)=>{
                console.log("查看支付结果",d)
                this.isPaySelect=false;
                this.loading=false;
                if(d.ResponseBody?.Timestamps){
                    this.parent.Timestamps = d.ResponseBody?.Timestamps;
                }
                if(d.ResponseHeader.ResultCode!=0){
                    let _error = d.ResponseHeader.ResultDesc;
                    if(d.ResponseHeader.ResultCode==4001){//用户输入支付密码中
                        if(this.isOutTime){//开启了60s 倒计时 再次调用
                            this.timeoutPayment();
                        }
                        return;
                    } 
                    else if(d.ResponseHeader.ResultCode==4003){//用户已经取消支付
                        this.psyOutTime=0;//停止支付倒计时
                        if(this._timePay) clearTimeout(this._timePay);
                        this.stopOutTime();
                        this.isOutTime=false;
                    }
                    this.errorMes=_error;
                }else{
                    this.errorMes="";
                    if(d.ResponseBody?.Payments?.length>0){
                        this.onPayPreview();
                    }
                    
                }
            }).catch((e)=>{
                this.loading=false;
                this.isPaySelect=false;
                this.errorMes=e.message;
            });
        },
        onPayPreview(){
            this.loadingShow('等待查询支付结果中......');
            this.parent.payPreview().then((d)=>{
                this.loading=false;
                if(d.ResponseHeader.ResultCode!=0){
                    this.errorMes=d.ResponseHeader.ResultDesc;
                    if(d.ResponseBody?.Timestamps){
                        this.parent.Timestamps = d.ResponseBody?.Timestamps.toString()
                    }
                }else{
                    this.errorMes="";
                    /**是否需要支付提交 0：不需要（说明快餐下单结账成功）， 1：需要（对接类支付方式预览后调用提交接口） */
                    if(d.ResponseBody.Is_NeedSubmit==0){
                        if(d.ResponseBody?.PrintsInfo){
                            setTimeout(()=>{
                                this.$webBrowser.posPrint(d.ResponseBody.PrintsInfo);
                            },100);
                        }
                        //支付成功
                        this.isComplete=true;
                    }else{
                        /**支付提交 */
                        this.PaySubmit(d);
                    }
                }
            }).catch((e)=>{
                this.loading=false;
                this.errorMes=e.message;
            })
        },
        paySubmit(data){
            this.loadingShow('等待查询支付结果中......');
            this.parent.PaySubmit(data).then((d)=>{
                this.loading=false;
                if(d.ResponseHeader.ResultCode!=0){
                    this.errorMes=d.ResponseHeader.ResultDesc;
                    return;
                }else{
                    if(d.ResponseBody?.PrintsInfo){//打印清单
                        setTimeout(()=>{
                            this.posPrint(d.ResponseBody?.PrintsInfo);
                        },100);
                    }
                    //结账完成
                    this.isComplete=true;
                }
            }).catch((e)=>{
                this.loading=false;
                this.errorMes=e.message;
            });
        }
    }
}
</script>

<style lang="scss" >
@import './scanPayModal.scss';
</style>